import React from "react";
import Card from "react-bootstrap/Card";
import CardGroup from "react-bootstrap/CardGroup";
import BoxData from "../Box";
import CardNav from "../CardNav";
import { BusinessDatatwo } from "../../../../constants/jsonConstant";
import { Col, Container, Row } from "react-bootstrap";
import { images } from "../../../../constants";

const SellPropertyOnline = ({ title }) => {
  return (
    <div>
      <Row>
        <CardNav Header={title} />
        {BusinessDatatwo.map((data) => (
          <Col lg="6" md="6" sm="6" xs="6">
            <Card className="shadow-joboprt">
              {(data.id === 1 && (
                <BoxData
                  Title="Bussiness Property"
                  Butonn="Create Shop"
                  imgg={images.SellProperties}
                  url="/property-integrate"
                  ms="fifteen-element"
                />
              )) ||
                (data.id === 2 && (
                  <BoxData
                    Title="Single Property"
                    Butonn="POST Ad"
                    imgg={images.SingleVehicle}
                    url="/add-personal-property"
                    ms="sixteen-element"
                  />
                ))}
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default SellPropertyOnline;
